
        var result = require("!!../../../../../node_modules/css-loader/index.js!./basic.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/layouts/basic.component.css
// module id = 457
// module chunks = 0